var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 45 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__flag-en_svg__clipPath1862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "none",
    paintOrder: "fill markers stroke",
    rx: 8.667,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__flag-en_svg__clipPath1866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "none",
    paintOrder: "fill markers stroke",
    rx: 8.667,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__flag-en_svg__clipPath1870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "none",
    paintOrder: "fill markers stroke",
    rx: 8.667,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__flag-en_svg__clipPath1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "none",
    paintOrder: "fill markers stroke",
    rx: 8.667,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__flag-en_svg__clipPath1878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "none",
    paintOrder: "fill markers stroke",
    rx: 8.667,
    ry: 6.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__flag-en_svg__s)",
    transform: "scale(.75 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2957bf",
    d: "M0 0v30h60V0z",
    clipPath: "url(#flag-en_svg__flag-en_svg__clipPath1878)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 6,
    d: "M0 0l60 30m0-30L0 30",
    clipPath: "url(#flag-en_svg__flag-en_svg__clipPath1874)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1445d",
    strokeWidth: 4,
    d: "M0 0l60 30m0-30L0 30",
    clipPath: "url(#flag-en_svg__flag-en_svg__clipPath1870)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "M30 0v30M0 15h60",
    clipPath: "url(#flag-en_svg__flag-en_svg__clipPath1866)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1445d",
    strokeWidth: 6,
    d: "M30 0v30M0 15h60",
    clipPath: "url(#flag-en_svg__flag-en_svg__clipPath1862)"
  }))));
};

;
export default SvgFlagEn;